import OnboardingPage from './OnboardingPage';

const OnboardingConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false
        },
        toolbar: {
          display: false
        },
        footer: {
          display: false
        }
      }
    }
  },

  auth: null,
  routes: [
    {
      path: '/v8N2kL9pX1',
      component: OnboardingPage
    }
  ]
};

export default OnboardingConfig;
